import * as React from "react"

import { DayPicker } from "react-day-picker"

import { cn } from "@/lib/utils"

export type CalendarProps = React.ComponentProps<typeof DayPicker>

function Calendar({ className, ...props }: CalendarProps) {
  // Default toYear to allow future years (50 years from now)
  // Individual components can override this if needed
  const defaultToYear = new Date().getFullYear() + 5

  return (
    <DayPicker
      captionLayout="dropdown"
      hideNavigation
      weekStartsOn={1}
      className={cn("p-3", className)}
      classNames={{
        day: "p-0 rounded-md hover:bg-primary/70",
        today: "text-palette-jungleGreen900 bg-palette-jungleGreen100",
        selected: "bg-primary text-primary-foreground",
        chevron: "text-primary-foreground",
      }}
      toYear={props.toYear ?? defaultToYear}
      {...props}
    />
  )
}
Calendar.displayName = "Calendar"

export { Calendar }
